import { useNavigate } from 'react-router-dom';
import './PageHeader.css';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faSearch, faRefresh } from '@fortawesome/free-solid-svg-icons';

export const PageHeader = (props: any) => {

  const {
    title,
    actions,
    back
  } = props;

  const navigate = useNavigate();

  return (
    <div className="page-header">
      <div className="page-h-content">
        {back ? (<div className="page-header--actions-left">
          <Button onClick={backPage} variant='primary' title='Voltar'>
            <FontAwesomeIcon icon={faChevronLeft} color={'var(--primary-text-color)'} />
          </Button>
        </div>) : null}
        <div className="page-header--title">
          {title}
        </div>
        <div className="page-header--actions-right">
          {actions?.map((action: any) => {
            let content = action.title;
            if (action.icon == 'search') {
              content = <FontAwesomeIcon icon={faSearch} color={'var(--primary-text-color)'} />;
            } else if (action.icon == 'refresh') {
              content = <FontAwesomeIcon icon={faRefresh} color={'var(--primary-text-color)'} />;
            }
            return (
              <Button
                key={`action-${action.name}`}
                variant='primary'
                onClick={() => action.onClick && action.onClick()}
                title={action.icon ? action.title : ''}
                style={{ marginLeft: '5px' }}
              >{content}</Button>
            )
          })}
        </div>
      </div>
    </div>
  )

  function backPage() {
    navigate(-1);
  }
}